function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["onClose"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import DialogTitle from "@mui/material/DialogTitle";
import debounce from "lodash/debounce";
import Dialog from "../../../../../components/mui/material/Dialog";
import Button from "../../../../../components/mui/material/Button";
import { useCurrentGroupContext } from "../../../contexts/CurrentGroupContext";
import { fetchUsersByUsernameContainingOrPersonLastNameContainingAndIdNotInAndEnabledAtNotNull, postGroupMembers } from "../../../../../actions";
import { roleIds } from "../../../../../constants";
import UsersAsync from "./UsersAsync";
var tKey = "features.Chat.Actions.AddGroupMembersDialog";
function AddGroupMembersDialog(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useCurrentGroupConte = useCurrentGroupContext(),
    currentGroup = _useCurrentGroupConte.currentGroup;
  var dispatch = useDispatch();
  var authUserId = useSelector(function (state) {
    return state.authentication.userId;
  });
  var authUser = useSelector(function (state) {
    return state.entities.users.byId[authUserId];
  });
  var usersCall = useSelector(function (state) {
    return state.apiCalls.fetchUsersByUsernameContainingOrPersonLastNameContainingAndIdNotInAndEnabledAtNotNull["undefined"];
  }) || {};
  var _useState = useState(currentGroup.members.filter(function (member) {
      return !member.deletedAt;
    }).map(function (member) {
      return member.user;
    })),
    _useState2 = _slicedToArray(_useState, 2),
    users = _useState2[0],
    setUsers = _useState2[1];
  function handleClickAdd(event) {
    event.preventDefault();
    if (!users || users.length === 0) return;
    var members = users.map(function (user) {
      return {
        groupId: currentGroup.id,
        userId: user.id,
        createdById: authUser.id,
        roleIds: [roleIds.USER]
      };
    });
    dispatch(postGroupMembers(members));
  }
  function loadOptions(input) {
    return dispatch(fetchUsersByUsernameContainingOrPersonLastNameContainingAndIdNotInAndEnabledAtNotNull(0, 10, input, input, users.map(function (user) {
      return user.id;
    }))).then(function (action) {
      var _embedded = action.response._embedded;
      return _embedded ? _embedded.users.map(function (user) {
        return _objectSpread({
          label: user.username,
          value: user.id
        }, user);
      }) : [];
    });
  }
  var loadOptionsCallback = useCallback(debounce(function (inputText, callback) {
    loadOptions(inputText).then(function (options) {
      return callback(options);
    });
  }, 1000), []);
  var forwardProps = function (_ref) {
    var onClose = _ref.onClose,
      rest = _objectWithoutProperties(_ref, _excluded);
    return rest;
  }(props);
  return /*#__PURE__*/React.createElement(Dialog, _extends({
    fullWidth: true,
    onClose: function onClose(event, reason) {
      return reason === "backdropClick" && props.onClose;
    },
    onKeyDown: function onKeyDown(e) {
      return e.stopPropagation();
    },
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description",
    PaperProps: {
      elevation: 0,
      sx: {
        overflow: "visible",
        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))"
      }
    },
    sx: {
      backdropFilter: "blur(5px) sepia(5%)"
    }
  }, forwardProps), /*#__PURE__*/React.createElement(DialogTitle, {
    display: "flex"
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      flexGrow: 1
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    component: "div",
    sx: {
      fontWeight: 400,
      fontSize: "1rem",
      lineHeight: "1.5",
      letterSpacing: "0.00938em"
    }
  }, t("".concat(tKey, ".addUsersToGroup"))), /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontWeight: 400,
      fontSize: "0.875rem",
      lineHeight: "1.43",
      letterSpacing: "0.01071em"
    }
  }, t("".concat(tKey, ".addPeople")))), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    onClick: handleClickAdd
  }, t("".concat(tKey, ".add")))), /*#__PURE__*/React.createElement(Box, {
    sx: {
      minHeight: 500
    }
  }, /*#__PURE__*/React.createElement(UsersAsync, {
    loading: usersCall.isFetching,
    loadOptions: loadOptionsCallback,
    onChange: function onChange(option) {
      return setUsers(option);
    }
  })));
}
export default AddGroupMembersDialog;